import {OrderConfig} from '@/store/Constraints';
import {OrderApi,DeliveryApi,CartApi} from '@/api/Api';
import {Axios,setAuthToken} from '@/api/Axios';

const OrderStore = {
    state: {
        cartCount:0,
        categories:[],
        orderType:0,
        selectedAddress:null,
        selectedStore:null,
        selectedStoreDetail:null,        
        selectedCategory:null,
        selectedMenu:null,
        selectedProduct:null,
        selectedItem:null,
        selectedItemOptions:[],
        orderData: {
            orderFrom:1
            ,order:{
                // // storeCode:''
                // // ,itemList:[] 
                // orderResult:null,
                // prePayResult:null,
            }
        },
        // deliveryData: {
        //     orderFrom:1
        //     // ,selectedAddress:{}
        //     ,order:{
        //         storeCode:''
        //         ,recvAddr1:''
        //         ,recvAddr2:''  
        //         ,deliveryRequest:''
        //         ,recvPhone:''              
        //         ,itemList:[]   
        //     }
        // },
    },
    getters: {
        [OrderConfig.CART_COUNT]: (state) => state.cartCount,
        [OrderConfig.CATEGORIES]: (state) => state.categories,

        [OrderConfig.ORDER_TYPE]: (state) => state.orderType,
        [OrderConfig.ORDER_DATA]: (state) => {
            return state.orderData;
            // if(state.orderType == 'ORD')
            //     return state.orderData;
            // else
            //     return state.deliveryData;
        },
        // [OrderConfig.GET_DELIVERY_DATA]: (state) => state.deliveryData,
        [OrderConfig.SELECTED_ADDRESS]: (state) => state.selectedAddress,
        [OrderConfig.SELECTED_STORE]: (state) => state.selectedStore,
        [OrderConfig.SELECTED_STORE_DETAIL]: (state) => state.selectedStoreDetail,
        
        [OrderConfig.SELECTED_CATEGORY]: (state) => state.selectedCategory,
        [OrderConfig.SELECTED_MENU]: (state) => state.selectedMenu,
        [OrderConfig.SELECTED_PRODUCT]: (state) => state.selectedProduct,
        [OrderConfig.SELECTED_ITEM]: (state) => state.selectedItem,
        [OrderConfig.SELECTED_ITEM_OPTIONS]: (state) => state.selectedItemOptions,
    },
    mutations: {
        [OrderConfig.CART_COUNT]:(state,payload) =>{
            console.log('OrderStore.mutations.CART_COUNT ->',payload);
            state.cartCount = payload;
        },

        [OrderConfig.CATEGORIES]:(state,payload) =>{
            console.log('OrderStore.mutations.CATEGORIES ->',payload);
            state.categories = payload;
        },

        [OrderConfig.ORDER_TYPE]:(state,payload) =>{
            console.log('OrderStore.mutations.ORDER_TYPE ->',payload);
            state.orderType = payload;
        },
        [OrderConfig.ORDER_DATA]:(state,payload) =>{
            console.log(`OrderStore.mutations.ORDER_DATA -> payload : ${JSON.stringify(payload)}`);
            state.orderData.order = payload;
            // if(state.orderType == 'ORD')
            //     state.orderData = payload;
            // else
            //     state.deliveryData = payload;
        },
        [OrderConfig.SELECTED_ADDRESS]:(state,payload) =>{
            console.log(`OrderStore.mutations.SELECTED_ADDRESS -> payload : ${JSON.stringify(payload)}`);
            state.selectedAddress = payload;
        },
        [OrderConfig.SELECTED_STORE]:(state,payload) =>{
            console.log(`OrderStore.mutations.SELECTED_STORE -> payload : ${JSON.stringify(payload)}`);            
            state.selectedStore = payload;
        },
        [OrderConfig.SELECTED_STORE_DETAIL]:(state,payload) =>{
            console.log(`OrderStore.mutations.SELECTED_STORE_DETAIL -> payload : ${JSON.stringify(payload)}`);
            
            state.selectedStoreDetail = payload;
        },
        [OrderConfig.SELECTED_CATEGORY]:(state,payload) =>{
            console.log(`OrderStore.mutations.SELECTED_CATEGORY -> payload : ${JSON.stringify(payload)}`);            
            state.selectedCategory = payload;
        },

        [OrderConfig.SELECTED_MENU]:(state,payload) =>{
            console.log(`OrderStore.mutations.SELECTED_MENU -> payload : ${JSON.stringify(payload)}`);            
            state.selectedMenu = payload;
            state.selectedProduct = null;
            state.selectedItem = null;
            state.selectedItemOptions = [];
        },
        [OrderConfig.SELECTED_PRODUCT]:(state,payload) =>{
            console.log(`OrderStore.mutations.SELECTED_PRODUCT -> payload : ${JSON.stringify(payload)}`);            
            state.selectedProduct = payload;
        },
        [OrderConfig.SELECTED_ITEM]:(state,payload) =>{
            console.log(`OrderStore.mutations.SELECTED_ITEM -> payload : ${JSON.stringify(payload)}`);            
            state.selectedItem = payload;
        },
        [OrderConfig.SELECTED_ITEM_OPTIONS]:(state,payload) =>{
            console.log(`OrderStore.mutations.SELECTED_ITEM_OPTIONS -> payload : ${JSON.stringify(payload)}`);            
            state.selectedItemOptions = payload;
        },
        [OrderConfig.INITIALIZE_ORDER_DATA]:(state,payload) =>{
            console.log('OrderStore.mutations.INITIALIZE_ORDER_DATA ->',payload);    
            
            state.selectedMenu=0;
            // state.selectedStore=null;
            state.selectedItemnull;
            state.selectedItemOptions=[];
            state.orderData = {
                    orderFrom:1
                    ,order:{
                        storeCode:'',
                        itemList:[] 
                    }
                },
            // state.deliveryData = {
            //     orderFrom:1
            //     ,selectedAddress:{}
            //     ,order:{
            //         storeCode:''
            //         ,recvAddr1:''
            //         ,recvAddr2:''  
            //         ,deliveryRequest:''
            //         ,recvPhone:''              
            //         ,itemList:[]   
            //     }
            // },
            
            console.log(state);
        },
        // ORDER_RESULT:'order_result',
        // ORDER_PAY_PREPAID_RESULT:'pay_prepaid_result',

        [OrderConfig.ORDER_RESULT]:(state,payload) =>{
            console.log('OrderStore.mutations.ORDER_RESULT ->',payload);
            state.orderData.order.orderResult = payload;
            // state.orderData["orderResult"] = payload;
        },
        [OrderConfig.ORDER_PREPAY_RESULT]:(state,payload) =>{
            console.log('OrderStore.mutations.ORDER_PAY_PREPAID_RESULT ->',payload);
            state.orderData.order.prePayResult = payload;
            // state.orderData["prePayResult"] = payload;
        },



        // ORDER_CART_EVENT: 'order_cart_event',
        // ORDER_DIRECT_EVENT: 'order_direct_event',

        // ORDER_PAY_EVENT: 'order_pay_event',
        // ORDER_PAY_COMPLETE_EVENT: 'order_pay_complete_event',
        // ORDER_CANCEL_EVENT: 'order_cancel_event',
        // GET_ORDER_HISTORY_LIST_EVENT: 'GET_ORDER_HISTORY_LIST_event',
        // GET_ORDER_HISTORY_DETAIL_EVENT: 'get_order_history_detail_event',
    
        // DELIVERY_CART_EVENT: 'delivery_cart_event',
        // DELIVERY_DIRECT_EVENT: 'delivery_direct_event',
        // DELIVERY_PAY_EVENT: 'delivery_pay_event',
        // DELIVERY_PAY_COMPLETE_EVENT: 'delivery_pay_complete_event',
        // DELIVERY_CANCEL_EVENT: 'delivery_cancel_event',
        // GET_DELIVERY_HISTORY_LIST_EVENT: 'get_delivery_history_list_event',
        // GET_DELIVERY_HISTORY_DETAIL_EVENT: 'get_delivery_history_detail_event',
    },
    actions: {
        [OrderConfig.INITIALIZE_ORDER_DATA]:(store,payload) =>{    
            console.log('OrderStore.actions.INITIALIZE_ORDER_DATA ->',payload);
            store.commit(OrderConfig.INITIALIZE_ORDER_DATA,payload)
        },

        //

        // 통신 action
        // ORDER_CART_EVENT: 'order_cart_event',
        [OrderConfig.ORDER_CART_EVENT]:(store,payload) =>{
            //axios 
        },
        // ORDER_DIRECT_EVENT: 'order_direct_event',
        [OrderConfig.ORDER_DIRECT_EVENT]:(store,payload) =>{
            payload.orderFrom = 0;  
            console.log('OrderStore.actions.ORDER_DIRECT_EVENT ->',payload);                      
            store.commit(OrderConfig.ORDER_DATA,payload);
            return new Promise(async(resolve,reject) => {
                Axios.post(OrderApi.ORDER_DIRECT,payload)
                .then(res => {
                    console.log(res);
                    if(res.code == "0000"){ 
                        store.commit(OrderConfig.ORDER_RESULT,res.data);
                    }
                    resolve(res);
                })
                .catch(err => {
                    console.log(err);
                    reject(err)                    
                })
            });
        },

        [OrderConfig.ORDER_CART_DIRECT_EVENT]:(store,payload) =>{
            payload.orderFrom = 1;
            console.log('OrderStore.actions.ORDER_CART_DIRECT_EVENT ->',payload);            
            store.commit(OrderConfig.ORDER_DATA,payload);
            return new Promise(async(resolve,reject) => {
                Axios.post(OrderApi.ORDER_CART,payload)
                .then(res => {
                    console.log(res);
                    if(res.code == "0000"){ 
                        store.commit(OrderConfig.ORDER_RESULT,res.data);
                    }
                    resolve(res);
                })
                .catch(err => {
                    console.log(err);
                    reject(err)                    
                })
            });
        },

        // ORDER_PAY_EVENT: 'order_pay_event',
        [OrderConfig.ORDER_PAY_EVENT]:(store,payload) =>{
            console.log('OrderStore.actions.ORDER_PAY_EVENT ->',payload);
            return new Promise(async(resolve,reject) => {
                Axios.post(OrderApi.ORDER_PAY,payload)
                .then(res => {
                    console.log(res);
                    if(res.code == "0000"){ 
                        store.commit(OrderConfig.ORDER_PREPAY_RESULT,res.data);                        
                    }
                    resolve(res);
                })
                .catch(err => {
                    console.log(err);
                    reject(err)                    
                })
            });

        },


        // DELIVERY_DIRECT_EVENT: 'delivery_direct_event',
        [OrderConfig.DELIVERY_DIRECT_EVENT]:(store,payload) =>{
            console.log('OrderStore.actions.DELIVERY_DIRECT_EVENT ->',payload);            
            store.commit(OrderConfig.ORDER_DATA,payload);
            return new Promise(async(resolve,reject) => {
                Axios.post(DeliveryApi.DELIVERY_DIRECT,payload)
                .then(res => {
                    console.log(res);
                    if(res.code == "0000"){ 
                        store.commit(OrderConfig.ORDER_RESULT,res.data);
                    }
                    resolve(res);
                })
                .catch(err => {
                    console.log(err);
                    reject(err)                    
                })
            });
        },

        [OrderConfig.DELIVERY_CART_DIRECT_EVENT]:(store,payload) =>{
            console.log('OrderStore.actions.DELIVERY_DIRECT_EVENT ->',payload);            
            store.commit(OrderConfig.ORDER_DATA,payload);
            return new Promise(async(resolve,reject) => {
                Axios.post(DeliveryApi.DELIVERY_CART_DIRECT,payload)
                .then(res => {
                    console.log(res);
                    if(res.code == "0000"){ 
                        store.commit(OrderConfig.ORDER_RESULT,res.data);
                    }
                    resolve(res);
                })
                .catch(err => {
                    console.log(err);
                    reject(err)                    
                })
            });
        },

        // DELIVERY_PAY_EVENT: 'delivery_pay_event',
        [OrderConfig.DELIVERY_PAY_EVENT]:(store,payload) =>{
            console.log('OrderStore.actions.DELIVERY_PAY_EVENT ->',payload);            
            return new Promise(async(resolve,reject) => {
                Axios.post(DeliveryApi.DELIVERY_PAY,payload)
                .then(res => {
                    console.log(res);
                    if(res.code == "0000"){ 
                        store.commit(OrderConfig.ORDER_PREPAY_RESULT,res.data);                        
                    }
                    resolve(res);
                })
                .catch(err => {
                    console.log(err);
                    reject(err)                    
                })
            });
        },


        // GET_ORDER_HISTORY_LIST_EVENT: 'GET_ORDER_HISTORY_LIST_event',
        [OrderConfig.GET_ORDER_HISTORY_LIST_EVENT]:(store,payload) =>{
            console.log('OrderConfig.action[GET_ORDER_HISTORY_LIST_EVENT]->',payload); 
            return new Promise(async(resolve,reject) => {
                Axios.get(OrderApi.GET_ORDER_HISTORY_LIST,payload)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
            }) 
        },

        // GET_ORDER_HISTORY_DETAIL_EVENT: 'get_order_history_detail_event',
        [OrderConfig.GET_ORDER_HISTORY_DETAIL_EVENT]:(store,payload) =>{
            console.log('OrderConfig.action[GET_ORDER_HISTORY_DETAIL_EVENT]->',payload); 
            return new Promise(async(resolve,reject) => {

                Axios.get(OrderApi.GET_ORDER_HISTORY_DETAIL,payload)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
            }) 
        },

        // ORDER_PAY_COMPLETE_EVENT: 'order_pay_complete_event',
        [OrderConfig.ORDER_PAY_COMPLETE_EVENT]:(store,payload) =>{
            console.log('OrderConfig.action[ORDER_PAY_COMPLETE_EVENT]->',payload); 
            return new Promise(async(resolve,reject) => {

                Axios.post(OrderApi.ORDER_PAY_COMPLETE,payload)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
            }) 
        },

        // ORDER_CANCEL_EVENT: 'order_cancel_event',
        [OrderConfig.ORDER_CANCEL_EVENT]:(store,payload) =>{
            
        },
    
        // DELIVERY_CART_EVENT: 'delivery_cart_event',
        [OrderConfig.DELIVERY_CART_EVENT]:(store,payload) =>{
            
        },

        // DELIVERY_PAY_COMPLETE_EVENT: 'delivery_pay_complete_event',
        [OrderConfig.DELIVERY_PAY_COMPLETE_EVENT]:(store,payload) =>{
            console.log('OrderConfig.action[DELIVERY_PAY_COMPLETE_EVENT]->',payload); 
            return new Promise(async(resolve,reject) => {

                Axios.post(DeliveryApi.DELIVERY_PAY_COMPLETE,payload)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
            }) 
        },

        // DELIVERY_CANCEL_EVENT: 'delivery_cancel_event',
        [OrderConfig.DELIVERY_CANCEL_EVENT]:(store,payload) =>{
            
        },

        // GET_DELIVERY_HISTORY_LIST_EVENT: 'get_delivery_history_list_event',
        [OrderConfig.GET_DELIVERY_HISTORY_LIST_EVENT]:(store,payload) =>{
                      
        },

        // GET_DELIVERY_HISTORY_DETAIL_EVENT: 'get_delivery_history_detail_event',
        [OrderConfig.GET_DELIVERY_HISTORY_DETAIL_EVENT]:(store,payload) =>{
            
        },

        [OrderConfig.GET_CART_COUNT_EVENT]:(store,payload) =>{
            console.log(`OrderConfig.action[GET_CART_COUNT_EVENT] -> ${JSON.stringify(payload)}`); 
            Axios.get(CartApi.GET_CART_COUNT,payload)
            .then(res => {                
                if(res.code == "0000"){
                    store.commit(OrderConfig.CART_COUNT,res.data.cnt);
                }
            })
            .catch(err => {        
                console.error('OrderStore.action.GET_CART_COUNT_EVENT ->',err); 
                // this.showAlert(err);             
            })
        },



    }
}
export default OrderStore;


// WEBPACK FOOTER //
// ./src/store/order/OrderStore.js